export enum GiftAndInheritanceType {
    AdvanceOfInheritance = 'AdvanceOfInheritance',
    Gift = 'Gift'
}
